// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { GridContainerProps } from "@monsma/MobiusOverrides/GridContainer/GridContainer";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    return {
        parameter: state.pages.orderHistory.getOrdersParameter,
    };
};

const mapDispatchToProps = {
    updateSearchFields,
};
type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderHistoryRmaFilterStyles {
    container?: GridContainerProps;
    onlyOpenCheckbox?: CheckboxProps;
    onlyOpenGridItem?: GridItemProps;
}

export const orderHistoryRmaFilterStyles: OrderHistoryRmaFilterStyles = {};

const styles = orderHistoryRmaFilterStyles;
const OrderHistoryRmaFilter: React.FunctionComponent<Props> = props => {
    const showRmaOnlyChangeHandler = (showRmaOnly: boolean) => {
        props.updateSearchFields({ ...props.parameter, showRmaOnly: showRmaOnly || false } as any);
    };

    return (
        <GridContainer {...styles.container} data-test-selector="orderHistory_showRmaOnly">
            <GridItem {...styles.onlyOpenGridItem}>
                <Checkbox
                    {...styles.onlyOpenCheckbox}
                    checked={(props.parameter as any).showRmaOnly}
                    onChange={(_, value) => {
                        showRmaOnlyChangeHandler(value);
                    }}
                    data-test-selector="orderHistory_showRmaOnlyFilter"
                >
                    {translate("Show RMA Only")}
                </Checkbox>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderHistoryRmaFilter),
    definition: {
        group: "Order History",
        displayName: "Show RMA Filter",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
